export default {
      id: "empty-usage",
      viewBox: "0 0 64 64",
      url: "/" + "assets/sprite.svg#empty",
      toString: function () {
        return this.url;
      }
    }